import { ResponseDto } from '@diritto/common/base/response.dto';
import { RollingCreateDto, RollingEditDto } from '@diritto/common/rolling/dtos/rolling.dto';
import { RollingResponseDto } from '@diritto/common/rolling/dtos/rolling.response.dto';
import { Http } from '@diritto/common/utils/requester/http';

export class RollingApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async createRolling(data: RollingCreateDto) {
    const res = await this.http.post<RollingCreateDto, RollingResponseDto>(`${this.url}/rollings`, data);
    return res.data;
  }

  async updateRolling(rollingId: number, data: RollingEditDto) {
    const res = await this.http.put<RollingEditDto, RollingResponseDto>(`${this.url}/rollings/${rollingId}`, data);
    return res.data;
  }

  async deleteRolling(rollingId: number): Promise<ResponseDto> {
    const res = await this.http.delete<ResponseDto>(`${this.url}/rollings/${rollingId}`);
    return res.data;
  }

  async getRolling(rollingId: number): Promise<RollingResponseDto> {
    const res = await this.http.get<RollingResponseDto>(`${this.url}/rollings/${rollingId}`);
    return res.data;
  }
}
